import {initializeApp} from 'firebase/app';
import {getRemoteConfig} from 'firebase/remote-config';

export const isProd = () => process.env.NODE_ENV == 'production';

export const firebaseInit = () => {
  const firebaseConfig = {
    apiKey: 'AIzaSyCqsCPKr9UpZF-VeNS9hX4OXp3oF5DAhik',
    authDomain: 'volt-web-app.firebaseapp.com',
    projectId: 'volt-web-app',
    storageBucket: 'volt-web-app.appspot.com',
    messagingSenderId: '200598813164',
    appId: '1:200598813164:web:adc6c7ddfb7bdad0c0a8c9',
    measurementId: 'G-WSGQFFRFN3',
  };

  const app = initializeApp(firebaseConfig);
  const remoteConfig = getRemoteConfig(app);
  remoteConfig.settings.minimumFetchIntervalMillis = 10000;

  return remoteConfig;
};
